module.exports = __webpack_public_path__ + "static/media/product-arrow-left.627d1fed.svg";